import { render, staticRenderFns } from "./UpdateWholesale.vue?vue&type=template&id=66e2fbb7&scoped=true&"
import script from "./UpdateWholesale.vue?vue&type=script&lang=ts&"
export * from "./UpdateWholesale.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateWholesale.vue?vue&type=style&index=0&id=66e2fbb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e2fbb7",
  null
  
)

export default component.exports